// import React from "react";
// import "./PricingSection.css";

// export default function PricingSection({ scrollToCTA, openDemo }) {

//     const addonList = [
//         { key: "chef", title: "Chef Management", desc: "Kitchen order display & chef assignments", price: 999 },
//         { key: "inventory", title: "Inventory Management", desc: "Stock tracking & purchase orders", price: 999 },
//         { key: "team", title: "Team Management", desc: "Staff scheduling & permissions", price: 999 },
//         { key: "sales", title: "Sales Management", desc: "Advanced sales tracking & targets", price: 999 },
//         { key: "delivery", title: "Service Management", desc: "Rider assignment & tracking", price: 999 },

//     ];
//     const orderTypes = [
//         { key: "deliveryorder", title: "Delivery Orders", desc: "Doorstep delivery workflows", price: 999 },
//         { key: "dineoutorder", title: "Dine-out Orders", desc: "Table service & billing", price: 999 },
//         { key: "catering", title: "Catering Orders", desc: "Bulk & event order workflows", price: 999 }
//     ];
//     return (
//         <div className="pricing-wrapper">

//             {/* HEADER */}
//             <div className="pricing-header">
//                 <h2 style={{ color: "#000" }}>
//                     Simple <span style={{ color: "#f44336" }}>Pricing</span>
//                 </h2>
//                 <p style={{ color: "#000" }}>
//                     One powerful base plan. Add only what you need.
//                 </p>
//             </div>

//             <div className="pricing-container">

//                 {/* LEFT CARD */}
//                 <div className="pricing-left">

//                     <div style={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "space-between",
//                         flexWrap: "wrap",
//                         gap: "10px",
//                         margin: "15px 0"
//                     }}>

//                         {/* LEFT: BASE PLAN TAG */}
//                         <span style={{
//                             background: "rgb(230 109 51)",
//                             padding: "6px 14px",
//                             borderRadius: "20px",
//                             color: "#fff",
//                             fontSize: "12px",
//                             whiteSpace: "nowrap"
//                         }}>
//                             Base Plan
//                         </span>

//                         {/* RIGHT: PRICE */}
//                         <div style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "10px"
//                         }}>
//                             <span style={{
//                                 textDecoration: "line-through",
//                                 color: "#999",
//                                 fontSize: "18px"
//                             }}>
//                                 ₹499
//                             </span>

//                             <span style={{
//                                 fontSize: "32px",
//                                 fontWeight: "700",
//                                 color: "#f44336"
//                             }}>
//                                 ₹1
//                             </span>

//                             <span style={{
//                                 fontSize: "14px",
//                                 color: "#555"
//                             }}>
//                                 /Year
//                             </span>
//                         </div>

//                     </div>


//                     <h3>Everything to Get Started</h3>

//                     {/* 🔥 PRICE SECTION */}


//                     <ul className="feature-list">
//                         <li>Dashboard</li>
//                         <li>Business Profile</li>
//                         <li>Settings and Controls</li>
//                         <li>Products and Prices</li>
//                         <li>Order Management</li>
//                         <li>Chef Management</li>
//                         <li>Team Management (1 Admin + 5 Users)</li>
//                         <li>Accounting Management</li>
//                         <li>Promotions and Marketing</li>
//                         <li>Reports Management</li>
//                         <li>Compliances Management</li>
//                         <li>Help Desk</li>
//                         <li>Notifications Management</li>
//                         <li>Rewards & Coupons</li>
//                         <li>Refer & Earn</li>
//                     </ul>

//                     <button className="start-btn" onClick={openDemo}>
//                         Get Started →
//                     </button>
//                 </div>

//                 <div className="pricing-right">

//                     <span className="badge yellow">Add-on Modules</span>

//                     <h3 style={{ color: "#000" }}>Scale As You Grow</h3>

//                     {/* 🔹 FEATURE ADD-ONS */}
//                     <p style={{
//                         fontWeight: "600",
//                         marginTop: "10px",
//                         color: "#000",
//                         fontSize: "14px"
//                     }}>
//                         {/* Feature Add-ons */}
//                     </p>

//                     {addonList.map((item) => (
//                         <div
//                             key={item.key}
//                             className="addon-item"
//                             style={{
//                                 display: "flex",
//                                 justifyContent: "space-between",
//                                 alignItems: "center",
//                                 padding: "12px 9px",
//                                 borderBottom: "1px solid #eee"
//                             }}
//                         >
//                             <div>
//                                 <h4 style={{ color: "#000", margin: "0" }}>
//                                     {item.title}
//                                 </h4>
//                                 <p style={{
//                                     margin: "4px 0",
//                                     fontSize: "13px",
//                                     color: "#666"
//                                 }}>
//                                     {item.desc}
//                                 </p>
//                             </div>

//                             <div style={{
//                                 fontWeight: "600",
//                                 color: "#f44336",
//                                 fontSize: "16px"
//                             }}>
//                                 ₹{item.price}
//                                 <span style={{ fontSize: "12px", color: "#888" }}>
//                                     /year
//                                 </span>
//                             </div>
//                         </div>
//                     ))}

//                     {/* 🔹 ORDER TYPES */}
//                     <p style={{
//                         fontWeight: "600",
//                         marginTop: "20px",
//                         color: "#000",
//                         fontSize: "14px"
//                     }}>
//                         Order Types
//                     </p>

//                     {orderTypes.map((item) => (
//                         <div
//                             key={item.key}
//                             className="addon-item"
//                             style={{
//                                 display: "flex",
//                                 justifyContent: "space-between",
//                                 alignItems: "center",
//                                 padding: "12px 9px",
//                                 borderBottom: "1px solid #eee"
//                             }}
//                         >
//                             <div>
//                                 <h4 style={{ color: "#000", margin: "0" }}>
//                                     {item.title}
//                                 </h4>
//                                 <p style={{
//                                     margin: "4px 0",
//                                     fontSize: "13px",
//                                     color: "#666"
//                                 }}>
//                                     {item.desc}
//                                 </p>
//                             </div>

//                             <div style={{
//                                 fontWeight: "600",
//                                 color: "#f44336",   // keep consistent
//                                 fontSize: "16px"
//                             }}>
//                                 ₹{item.price}
//                                 <span style={{ fontSize: "12px", color: "#888" }}>
//                                     /year
//                                 </span>
//                             </div>
//                         </div>
//                     ))}

//                 </div>

//             </div>
//         </div>
//     );
// }



import React from "react";
import "./PricingSection.css";

export default function PricingSection({ scrollToCTA, openDemo }) {

    const addonList = [
        { key: "chef", title: "Chef Management", desc: "Kitchen order display & chef assignments", price: 999 },
        { key: "inventory", title: "Inventory Management", desc: "Stock tracking & purchase orders", price: 999 },
        { key: "team", title: "Team Management", desc: "Staff scheduling & permissions", price: 999 },
        { key: "sales", title: "Sales Management", desc: "Advanced sales tracking & targets", price: 999 },
        { key: "delivery", title: "Service Management", desc: "Rider assignment & tracking", price: 999 },
    ];
    
    const orderTypes = [
        { key: "deliveryorder", title: "Delivery Orders", desc: "Doorstep delivery workflows", price: 999 },
        { key: "dineoutorder", title: "Dine-out Orders", desc: "Table service & billing", price: 999 },
        { key: "catering", title: "Catering Orders", desc: "Bulk & event order workflows", price: 999 }
    ];
    
    return (
        <div className="pricing-wrapper">
            {/* HEADER */}
            <div className="pricing-header">
                <h2>
                    Simple <span className="highlight-text">Pricing</span>
                </h2>
                <p>
                    One powerful base plan. Add only what you need.
                </p>
            </div>

            <div className="pricing-container">
                {/* LEFT CARD */}
                <div className="pricing-left">
                    <div className="pricing-left-header">
                        <span className="base-plan-tag">Base Plan</span>
                        <div className="price-wrapper">
                            <span className="original-price">₹4999</span>
                            <span className="current-price">₹1</span>
                            <span className="price-duration">/Year</span>
                        </div>
                    </div>

                    <h3 className="plan-title">Everything to Get Started</h3>

                    <ul className="feature-list">
                        <li>Dashboard</li>
                        <li>Business Profile</li>
                        <li>Settings and Controls</li>
                        <li>Products and Prices</li>
                        <li>Order Management</li>
                        <li>Chef Management</li>
                        <li>Team Management (1 Admin + 5 Users)</li>
                        <li>Accounting Management</li>
                        <li>Promotions and Marketing</li>
                        <li>Reports Management</li>
                        <li>Compliances Management</li>
                        <li>Help Desk</li>
                        <li>Notifications Management</li>
                        <li>Rewards & Coupons</li>
                        <li>Refer & Earn</li>
                    </ul>

                    <button className="start-btn" onClick={openDemo}>
                        Get Started →
                    </button>
                </div>

                <div className="pricing-right">
                    <span className="badge yellow">Add-on Modules</span>
                    <h3 className="addon-title">Scale As You Grow</h3>

                    {/* Feature Add-ons */}
                    <p className="section-label">Feature Add-ons</p>

                    {addonList.map((item) => (
                        <div key={item.key} className="addon-item">
                            <div className="addon-info">
                                <h4>{item.title}</h4>
                                <p>{item.desc}</p>
                            </div>
                            {/* <div className="addon-price">
                                ₹{item.price}
                                <span>/year</span>
                            </div> */}
                        </div>
                    ))}

                    {/* Order Types */}
                    <p className="section-label">Order Types</p>

                    {orderTypes.map((item) => (
                        <div key={item.key} className="addon-item">
                            <div className="addon-info">
                                <h4>{item.title}</h4>
                                <p>{item.desc}</p>
                            </div>
                            {/* <div className="addon-price">
                                ₹{item.price}
                                <span>/year</span>
                            </div> */}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}